'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var menu = exports.menu = {
  home: 'Inicio',
  careers: 'Carreras',
  courses: 'Cursos'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/es/menu.js
// module id = 701
// module chunks = 0